module.exports = __webpack_public_path__ + "img/error_icon.e1004a40.jpg";